<template>
    <b-modal
        id="personal-goal-add-modal"
        v-model="modal"
        modal-class="apprentice-default-modal personal-goal-add-modal"
        :title="$t('common.add_learning_goal')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk">
        <div class="add-personal-goal">
            <div class="errors">
                <b-alert
                    v-if="error"
                    show
                    variant="danger">
                    {{ $t('personal_goals.name_learning_goal_cannot_be_empty') }}
                </b-alert>
            </div>
            <b-form-group
                :label="$t('personal_goals.name_learning_goal')"
                label-for="personal-goal-add-title-label">
                <b-form-input
                    id="personal-goal-add-title-label"
                    v-model="text"
                    :placeholder="$t('personal_goals.name_learning_goal')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="skills-select-group"
                :label="$t('personal_goals.skills')">
                <design2021-apprentice-multiselect-component
                    v-model="selectedSkills"
                    :options="skillTreesIn"
                    track-by="id"
                    group-label="name"
                    group-values="skills"
                    label="name"
                    :placeholder="$t('personal_goals.choose_one_or_more_skills')"
                    :multiple-select="true"
                    :allow-empty="true">
                </design2021-apprentice-multiselect-component>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';
import Design2021ApprenticeMultiselectComponent from '../../common/design-2021-apprentice-multiselect-component.vue';

export default {
    name: 'design-2021-personal-goal-add-personal-goal-modal-component',
    components: { Design2021ApprenticeMultiselectComponent },
    props: {
        skillTreesIn: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
        return {
            modal: false,
            text: '',
            error: false,
            selectedSkills: [],
        };
    },

    methods: {
        show() {
            this.text = '';
            this.modal = true;
            this.error = false;
            this.selectedSkills = [];
        },

        onOk(bvModalEvt) {
            this.error = false;

            if (this.text === '' || this.text === null) {
                this.error = true;
            }

            if (this.error) {
                bvModalEvt.preventDefault();
                return;
            }

            const data = new FormData();

            data.append('name', this.text);
            for (let i = 0; i < this.selectedSkills.length; i++) {
                data.append(`skill[${i}][id]`, this.selectedSkills[i].id);
            }

            this.alert.saving();
            this.axios.post(this.routes.personalGoal(), data).then(
                (response) => {
                    ords.use('personalGoal').add(response.data);
                    ords.use('personalGoal').attach(this.sectionId, 'skills', response.data.id);

                    ords.hold();
                    for (const skill of response.data.skills) {
                        ords.use('personalGoal').attach(response.data.id, 'skills', skill);
                    }
                    ords.continue();

                    let goal = {};
                    ords.use('personalGoal')
                        .find(response.data.id)
                        .subscribe((personalgoal) => {
                            goal = personalgoal;
                        });

                    this.alert.success();
                    Vue.nextTick(() => {
                        this.$emit('add-task', goal);
                    });
                },
                (error) => {
                    return this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss"></style>
